export function getUgcSettings(ugcTypes) {
  const hasText = ugcTypes.includes('text');
  const hasVideo = ugcTypes.includes('video');
  const hasUpload = ugcTypes.includes('upload');
  const isSingleTypeIncluded = ugcTypes.length === 1;

  return {
    hasText,
    hasVideo,
    hasUpload,
    ugcTextOnly: hasText && isSingleTypeIncluded,
    ugcUploadOnly: hasUpload && isSingleTypeIncluded,
    ugcVideoOnly: hasVideo && isSingleTypeIncluded,
  };
}
